import { render } from "./HomeLink.vue?vue&type=template&id=5a374040&scoped=true"
import script from "./HomeLink.vue?vue&type=script&lang=js"
export * from "./HomeLink.vue?vue&type=script&lang=js"

import "./HomeLink.vue?vue&type=style&index=0&id=5a374040&scoped=true&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a374040"]])

export default __exports__